module.exports = __webpack_public_path__ + "img/apple-app-store-btn-POLAND-pl.e662e770.svg";